export default __webpack_public_path__ + "static/media/1_star_giftcard_inviter.4422ebd1.svg";